// SidePanel.tsx
import React from 'react';
import { CardContent, Stack } from '@mui/material';
import LayerList from '../map/LayerList';
import "./SidePanel.css"; // Import the CSS file
import { useCurrentPopup } from '../../contexts/PopupContext';

interface SidePanelProps {
  onClose: () => void;
  open: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({ onClose, open }) => {
  const { popupContent, clearPopup } = useCurrentPopup();
  if (!open) {
    return null;
  }

  return (
    <div className="sidePanel">
      <CardContent sx={{ padding: '16px !important', paddingTop: '0 !important' }}>
        <Stack spacing={2}>
          <LayerList />
          {/* Hide the FeatureInfoPanel for now */}
          {/* <FeatureInfoPanel content={popupContent} onClose={clearPopup} /> */}
        </Stack>
      </CardContent>
    </div>
  );
};

export default SidePanel;
